import React from 'react'
import ArticlePostItem from "./ArticlePostItem";
import {authService} from "../auth";
import axios from "axios";

import httpService from '../AxiosInterceptors';
import InfiniteScroll from "react-infinite-scroller";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import $ from "jquery";
import cloneDeep from 'lodash/cloneDeep';
import {Link} from "react-router-dom";
import { userAgentGetData } from '../commons/CommonFunctions';
import CommonFeedsZeroData from './CommonFeedsZeroData';

httpService.setupInterceptors();

const currentyYear = new Date().getFullYear();

class ArticlePostList extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            postList: [],
            userData: authService.getUserDetailsFromLocalStorage(),
            responseMessage: '',
            postMaxSize: 5,
            thresholdHeight: 1000
        };
    }

    componentDidMount() {
        this.getArticlePosts(0, this.state.postMaxSize, false);
    }

    callback_fn = (userId) => {
        this.updateFollowList(userId)
    }

    updateFollowList = (userId) => {
        if (this.state.postList && this.state.postList.content && this.state.postList.content.length > 0) {
            let postList = cloneDeep(this.state.postList);
            postList && postList.content && postList.content.forEach((item) => {
                if (item.userId === userId) {
                    item.followed = !item.followed;
                }
            });
            this.setState({'postList': postList});
        }
    }

    getArticlePosts(page, size, concatWithPrevious) {
        let hideFlag = this.props.hideFlag ? true : false;
        axios({
            method: 'get',
            url: process.env.REACT_APP_userServiceURL + '/post/getNewsFeed?userId=' + this.state.userData.userId
                + '&newsFeedType=ARTICLES&page=' + page + '&size=' + size + userAgentGetData(),
            headers: {'Content-Type': 'application/json'},
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.body && response.status === 200) {
                let pagedData = response.data.body;
                if (concatWithPrevious === true && this.state.postList && this.state.postList.content) {
                    pagedData.content = this.state.postList.content.concat(pagedData.content);
                }
                this.setState({
                    'postList': pagedData,
                    'responseMessage': response.data.message,
                    'isResultLoading': false
                }, () => {
                    let postListHeight = $('.hpostlist').height();
                    if (postListHeight && postListHeight > 0) {
                        if (!this.state.initialThresholdHeight) {
                            this.setState({
                                'initialThresholdHeight': postListHeight,
                                'thresholdHeight': postListHeight * 0.6
                            });
                        }
                    }
                });
            }
        }).catch((err) => {
            console.log(err);
            this.setState({
                isResultLoading: false,
                responseMessage: err.response.data.status
            });
        });
    }

    fetchMorePostData() {
        let postList = this.state.postList;

        if (this.state.postList && this.state.postList.page && this.state.postList.page.pageable) {
            this.setState({isResultLoading: true});
            let pageable = postList.page.pageable;
            this.getArticlePosts(pageable.pageNumber + 1, this.state.postMaxSize, true);
        }
    }

    removePostListItem = (id) => {
        let postItemList = this.state.postList;
        const index = postItemList && postItemList.content.findIndex(data => data.id === id);
        if (index > -1) {
            postItemList.content.splice(index, 1); 
        }
        this.setState({
          postList: postItemList
        });
        if(postItemList?.content.length === 0) {
            this.getArticlePosts(!postItemList.page?.last ? postItemList.page?.pageable?.pageNumber + 1 :  0, this.state.postMaxSize, false);
        }
        this.forceUpdate();
    }

    render() {
        let content;
        if ((this.state.postList && this.state.postList.content && this.state.postList.content.length === 0
            && this.state.responseMessage === "Success!") || (this.state.postList && this.state.postList.length === 0 && this.state.responseMessage === "Success!") || this.state.responseMessage == "400 BAD_REQUEST" ) {
            content = <CommonFeedsZeroData />
        } else if (this.state.postList && this.state.postList.content && this.state.postList.content.length > 0
            && this.state.responseMessage === "Success!" /*&& this.state.postList.empty === false*/) {

            content = <section className="hpostlist">
                {this.state.postList.content[0].showZeroData && this.state.userData.type !== "COMPANY" &&
                <CommonFeedsZeroData />
            }
                <InfiniteScroll
                loadMore={this.fetchMorePostData.bind(this)}
                hasMore={!this.state.isResultLoading && this.state.postList && this.state.postList.page && !this.state.postList.page.last}
                threshold={this.state.thresholdHeight}
                loader={<section>
                    {Array(1)
                        .fill()
                        .map((item, index) => (
                            <SkeletonTheme>
                                <div className="hpostblock" key={index}>
                                    <figure className="userimg">
                                        <Skeleton circle={true} height={50} width={50}/>
                                    </figure>
                                    <div className="hpostblockinn">
                                        <div className="hposthead">
                                            <h3>
                                                <Skeleton height={36} width={`80%`}/>
                                            </h3>
                                            <div className="hpostdtls">
                                                <Skeleton height={36} width={`30%`}/>
                                            </div>
                                            <div className="hpostcontent">
                                                <div className="hpostconttop">
                                                    <p><Skeleton height={120} width={`100%`}/></p>
                                                </div>
                                            </div>
                                            <div className="card-metrics">
                                                <Skeleton width={`90%`}/>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </SkeletonTheme>
                        ))}
                </section>}
            >
                {
                    this.state.postList.content.map((item) => {
                        return <ArticlePostItem enablePostSharing={true} item={item} key={item.id}
                                                callback_fn={() => this.callback_fn(item.userId)} removePostListItem={this.removePostListItem} postSection="FEED" year={currentyYear} />
                    })
                }
            </InfiniteScroll></section>;
        } else {
            content = <section>
                {Array(9)
                    .fill()
                    .map((item, index) => (
                        <SkeletonTheme>
                            <div className="hpostblock" key={index}>
                                <figure className="userimg">
                                    <Skeleton circle={true} height={50} width={50}/>
                                </figure>
                                <div className="hpostblockinn">
                                    <div className="hposthead">
                                        <h3>
                                            <Skeleton height={36} width={`80%`}/>
                                        </h3>
                                        <div className="hpostdtls">
                                            <Skeleton height={36} width={`30%`}/>
                                        </div>
                                        <div className="hpostcontent">
                                            <div className="hpostconttop">
                                                <p><Skeleton height={120} width={`100%`}/></p>
                                            </div>
                                        </div>
                                        <div className="card-metrics">
                                            <Skeleton width={`90%`}/>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </SkeletonTheme>
                    ))}
            </section>;
        }
        return <div>{content}</div>
    }
}

export default ArticlePostList
